import React, { createContext, useContext } from "react";

type StepContextValueT = {
  data: Record<string, unknown>;
  valid: boolean;
  touched: boolean;
  setData: <ValueT>(key: string, value: ValueT) => void;
  setValid: (status: boolean) => void;
  setTouched: (status: boolean) => void;
};

const errorFn = () => {
  throw new Error("Context not initialized");
};

export const StepContext = createContext<StepContextValueT>({
  data: {},
  touched: false,
  valid: false,
  setData: errorFn,
  setValid: errorFn,
  setTouched: errorFn,
});

type ProviderPropsT = React.PropsWithChildren<StepContextValueT>;

export function StepContextProvider({ children, ...rest }: ProviderPropsT) {
  return <StepContext.Provider value={rest}>{children}</StepContext.Provider>;
}
